import React, { FC, SyntheticEvent, useEffect } from 'react';
import { TextArea, FieldState, useFieldApi } from 'informed';
import cn from 'classnames';
import './styles.scss';

export interface ITextAreaField {
  name: string;
  placeholder?: string;
  className?: string;
  defaultValue?: string;
  label?: string;
  rows?: number;
  validate?: (value: unknown, values: Record<string, unknown>) => unknown;
  onBlur?: ((fieldState: FieldState, event: SyntheticEvent<Element, Event>) => void) | undefined;
  onChange?: ((fieldState: FieldState, event: SyntheticEvent<Element, Event>) => void) | undefined;
}

const TextAreaField: FC<ITextAreaField> = ({
  name,
  className,
  defaultValue = '',
  label,
  ...rest
}) => {
  const { setValue } = useFieldApi(name);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue, setValue]);

  return (
    <>
      {label && (
        <label htmlFor={name} className="hbh-text-area-label">
          {label}
        </label>
      )}
      <TextArea className={cn('hbh-text-area-field', className)} name={name} {...rest} />
    </>
  );
};

export default TextAreaField;
